import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/typographyStyle';

interface IRootProps extends ITypographyProps {
	className: string;
	isNewDashboardEnabled?: boolean;
}

const RootFont = React.memo(
	({
		children,
		className,
		color = 'primary-light',
		disableMargin = false,
		inline = false,
		useNewLine = false,
		title = '',
		dir = '',
		customClassName,
		//pass changeFontSize false when same font size is required for english and arabic. Default value is true
		changeFontSize = true,
		isNewDashboardEnabled = false,
		asSpan = false,
	}: IRootProps) => {
		// @ts-ignore
		const useStyles = makeStyles(styles);
		const classes = useStyles({ changeFontSize: changeFontSize, isNewDashboardEnabled });
		const fontClass = classNames({
			// @ts-ignore
			[customClassName]: true,
			[classes[className]]: true,
			[classes[color]]: true,
			[classes.disableMargin]: disableMargin,
			[classes.inline]: inline,
			[classes.useNewLine]: useNewLine,
			[changeFontSize]: true,
		});

		return asSpan ? (
			<span dir={dir} title={title} className={fontClass}>
				{children}
			</span>
		) : (
			<p dir={dir} title={title} className={fontClass}>
				{children}
			</p>
		);
	}
);

interface ITypographyProps {
	children?: React.ReactElement | string | null;
	color?:
		| 'primary-light'
		| 'secondary-light'
		| 'disabled-light'
		| 'primary-dark'
		| 'secondary-dark'
		| 'disabled-dark'
		| 'success'
		| 'danger'
		| 'brand'
		| 'brand-secondary'
		| 'enterprise'
		| 'success-light';
	disableMargin?: boolean;
	inline?: boolean;
	className?: string;
	useNewLine?: boolean;
	title?: string;
	dir?: string;
	customClassName?: Object;
	//pass changeFontSize false when same font size is required for english and arabic. Default value is true
	changeFontSize?: any;
	isNewDashboardEnabled?: boolean;
	asSpan?: boolean;
}

export const DisplayL = React.memo((props: ITypographyProps) => {
	return <RootFont className={'displayL'} {...props} />;
});

export const DisplayM = React.memo((props: ITypographyProps) => {
	return <RootFont className={'displayM'} {...props} />;
});

export const DisplayS = React.memo((props: ITypographyProps) => {
	return <RootFont className={'displayS'} {...props} />;
});

export const HeadingL = React.memo((props: ITypographyProps) => {
	return <RootFont className={'headingL'} {...props} />;
});

export const HeadingLBold = React.memo((props: ITypographyProps) => {
	return <RootFont className={'headingLBold'} {...props} />;
});
export const HeadingXLBold = React.memo((props: ITypographyProps) => {
	return <RootFont className={'headingXLBold'} {...props} />;
});
export const HeadingM = React.memo((props: ITypographyProps) => {
	return <RootFont className={'headingM'} {...props} />;
});

export const HeadingMBold = React.memo((props: ITypographyProps) => {
	return <RootFont className={'headingMBold'} {...props} />;
});
export const HeadingXSBold = React.memo((props: ITypographyProps) => {
	return <RootFont className={'headingXSBold'} {...props} />;
});

export const HeadingS = React.memo((props: ITypographyProps) => {
	return <RootFont className={'headingS'} {...props} />;
});

export const HeadingSBold = React.memo((props: ITypographyProps) => {
	return <RootFont className={'headingSBold'} {...props} />;
});

export const BodyM = React.memo((props: ITypographyProps) => {
	return <RootFont className={'bodyM'} {...props} />;
});

export const BodyMBold = React.memo((props: ITypographyProps) => {
	return <RootFont className={'bodyMBold'} {...props} />;
});

export const BodyS = React.memo((props: ITypographyProps) => {
	return <RootFont className={'bodyS'} {...props} />;
});
export const BodyL = React.memo((props: ITypographyProps) => {
	return <RootFont className={'bodyL'} {...props} />;
});
export const BodySBold = React.memo((props: ITypographyProps) => {
	return <RootFont className={'bodySBold'} {...props} />;
});

export const DescriptionM = React.memo((props: ITypographyProps) => {
	return <RootFont className={'descriptionM'} {...props} />;
});

export const DescriptionS = React.memo((props: ITypographyProps) => {
	return <RootFont className={'descriptionS'} {...props} />;
});

export const Caption = React.memo((props: ITypographyProps) => {
	return <RootFont className={'caption'} {...props} />;
});

export const CaptionBold = React.memo((props: ITypographyProps) => {
	return <RootFont className={'captionBold'} {...props} />;
});

export const CaptionLight = React.memo((props: ITypographyProps) => {
	return <RootFont className={'captionLight'} {...props} />;
});

export const Danger = React.memo((props: ITypographyProps) => {
	return <BodyS {...props} disableMargin color="danger" />;
});

export const DangerBold = React.memo((props: ITypographyProps) => {
	return <BodySBold {...props} disableMargin color="danger" />;
});

export const Success = React.memo((props: ITypographyProps) => {
	return <BodyS {...props} disableMargin color="success" />;
});

export const SuccessBold = React.memo((props: ITypographyProps) => {
	return <BodySBold {...props} disableMargin color="success" />;
});
export const Button = React.memo((props: ITypographyProps) => {
	return <RootFont className={'button'} {...props} disableMargin />;
});
